import type { UserNotificationStatus } from 'dynamo-daos/build/models/misc/userNotificationRecord';

import type { UserNotification } from '../types';
import apiRequest from './apiRequest';

export default async function putNotificationStatus(
  notificationID: string,
  body: {
    status: UserNotificationStatus;
  },
) {
  return apiRequest<UserNotification>(
    'user',
    `/users/notifications/${notificationID}`,
    {
      method: 'PUT',
      body: JSON.stringify(body),
    },
  );
}
